import React from 'react';
import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import * as allConstants from '../constants/allConstants';
import {useSelector} from 'react-redux';


const PrivateiPermitRoute = ({children, allowedRoles}) => {
  const user = useSelector(state=> state.user);
  const company = useSelector(state => state.company);

  const {isAuthenticated, role, companyId, isFetching} = user;
  const isiPermit = Object.values(allConstants.IPERMIT_ROLES).includes(role);
  const isParentCompany = role == allConstants.ROLES.COMPANY_ADMIN && company?.childCompanies?.length > 0;
  const isImpersonating = companyId;
  const {USER_FIELDS} = allConstants;

  // console.log('inside private permit route');
  // console.log('user role => ', role);


  if(isFetching) {
    return children;
  }

  if (!isFetching && !isAuthenticated) {
    // console.log('!isFetching && !isAuthenticated && !authPending',isFetching, isAuthenticated, authPending)
    // console.log("NAV To LOGIN!!!!")
    return <Navigate to={allConstants.PATH.LOGIN} replace={true} />;
  }
  if(!isiPermit && !isParentCompany) {
    return <Navigate to={allConstants.PATH.ACCESS_DENIED}/>;
  } else if(isImpersonating) {
    // console.log('loc', location);
  }

  // Routes that need more than "is iPermit staff" pass their own allowlist.
  // Without it the default above also admits IPERMIT_USER and any parent-company
  // COMPANY_ADMIN, which is wider than several of the APIs behind these pages.
  if(allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={allConstants.PATH.ACCESS_DENIED}/>;
  }

  if(user && user?.[USER_FIELDS.IS_CONNECT_TO_CHEERS_REQUESTED.api_name] && !user[USER_FIELDS.HAS_CONNECTED_TO_CHEERS.api_name]){

    return <Navigate to={allConstants.PATH.CHEERS_CONNECTION_REQUIRED}/>;
  }


  return children;
};

PrivateiPermitRoute.propTypes = {
  children:  PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};

PrivateiPermitRoute.defaultProps = {
  children: null,
  allowedRoles: undefined,
};

export default PrivateiPermitRoute;
